/**
 * Created by anatoly on 25.06.2025
 */

const Merge2UnitsShopTutorial = function () {
    return new TutorialScenario("merge2_units_shop_tutorial", {
        onStart: () => {
            cleverapps.focusManager.showControlsWhileFocused(["ControlButtonsView"]);
        },

        listSteps: () => [
            Merge2UnitsShopTutorial.createIconStep(),
            Merge2UnitsShopTutorial.createFreeTileStep(),
            Merge2UnitsShopTutorial.createExitStep()
        ],

        isAvailable: function () {
            const tab = cleverapps.unitsShop.tabs[ShopWindow.TABS.UNITS_RESOURCE];

            return Merge2.current
                && Merge2.current.mode === Merge2.MODE_GAME
                && !cleverapps.forces.isShown(Forces.UNITS_SHOP_ICON)
                && !Merge2.current.counter.isActive()
                && Merge2.current.field.countEmptySlots() > 0
                && cleverapps.unitsShop.isAvailable()
                && Boolean(tab && tab.getFreeProduct());
        }
    });
};

Merge2UnitsShopTutorial.createIconStep = function () {
    const options = {
        onStart: function () {
            const createForce = () => {
                const scene = cleverapps.Scenes.GetRunningScene();

                const controlButtons = ComponentUtils.findComponentByName(scene, "UpMenuController").getControlButtonsComponent();
                const shopIcon = controlButtons.findButton(Merge2UnitShopControlButton);

                const force = cleverapps.clone(Forces.UNITS_SHOP_ICON, true);
                force.text = "Merge2.UnitsShopTutorial1";
                force.position = MinimalDialogue.POSITIONS.TOP_LOWER;

                this.force = Merge2TutorialHelper.createForce(shopIcon, force);
            };

            createForce();

            cleverapps.tutorial.on("window_shown", this.finish.bind(this), this);
        },

        onFinish: function () {
            this.force.hideForceHints();
            Merge2.current.counter.trigger();
        }
    };

    return new TutorialStep(options);
};

Merge2UnitsShopTutorial.createFreeTileStep = function () {
    const options = {
        onStart: function () {
            if (!cleverapps.focusManager.currentWindow()) {
                this.finish();
                return;
            }

            const createForce = () => {
                const window = cleverapps.focusManager.currentWindow();
                const controller = ComponentUtils.findComponentByName(window, "ShopWindowController");
                const tutorialTile = controller.tiles.find((tile) => controller.getTileController(tile).source.isTutorialTile());

                controller.scroll.scrollTo(tutorialTile, 0);

                this.force = Merge2TutorialHelper.createForce(tutorialTile, {
                    text: "Merge2.UnitsShopTutorial3",
                    finger: { tap: ComponentUtils.findChildByName(tutorialTile, "button") }
                }, {
                    highlights: [window]
                });
            };

            createForce();

            cleverapps.tutorial.on("onResize", () => {
                if (cleverapps.forces.isRunningForce()) {
                    cleverapps.forces.closeRunningForce();
                }
                createForce();
            }, this);

            cleverapps.tutorial.on("unit_shop_buy", this.finish.bind(this), this);
            cleverapps.tutorial.on("shop_purchase_cancelled", this.finish.bind(this), this);
        },

        onFinish: function () {
            this.force && this.force.hideForceHints();
            Merge2.current.counter.trigger();
        }
    };

    return new TutorialStep(options);
};

Merge2UnitsShopTutorial.createExitStep = function () {
    const options = {
        onStart: function () {
            if (!cleverapps.focusManager.currentWindow()) {
                this.finish();
                return;
            }

            const createForce = () => {
                const window = cleverapps.focusManager.currentWindow();
                const unitsController = ShopWindow.getUnitsController(window);

                this.force = Merge2TutorialHelper.createForce(ComponentUtils.findChildByName(window, "closeButton"), {
                    text: "Merge2.UnitsShopTutorial4"
                }, {
                    importantNodes: [
                        ComponentUtils.findChildByName(window, "shopGrid"),
                        unitsController.bottomLine,
                        unitsController.tabs,
                        ComponentUtils.findChildByName(window, "title")
                    ].filter(Boolean),
                    highlights: [window]
                });
            };

            createForce();

            cleverapps.tutorial.on("onResize", () => {
                if (cleverapps.forces.isRunningForce()) {
                    cleverapps.forces.closeRunningForce();
                }
                createForce();
            }, this);

            cleverapps.tutorial.on("window_closed", (options) => {
                if (options.windowName !== `shopwindow_tab${ShopWindow.TABS.UNITS_RESOURCE}`) {
                    return;
                }

                this.finish();
            }, this);
        },

        onFinish: function () {
            this.force && this.force.hideForceHints();
            Merge2.current.counter.trigger();
        }
    };

    return new TutorialStep(options);
};